//
// Integrations CaseFolder Upload Folder Selection Widget
//
// Shows current casefolder upload path with an edit button that will open the
// upload folder selection tree.
//
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Button, ProgressBar} from 'react-bootstrap';
import UploadFolderTree from "./UploadFolderTree";
import Notification, { notify } from 'common/Notification';
import request from 'superagent';
import SharepointCasefolderSettings from "./SharepointCasefolderSettings";

export default class UploadFolderSelect extends Component {
  static defaultProps = {
    connectionId: null,
    casefolderId: null,
    courtCode: null,
    caseNumber: null,
    service: null,
  };

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    casefolderId: PropTypes.number.isRequired,
    service: PropTypes.string.isRequired,
    uploadFolder: PropTypes.string,
  };

  state = {
    isFolderTreeOpen: false,
    isSavingFolderPath: false,
    uploadFolder: null,
    newFolderPath: [],
  };

  async componentDidMount() {
    await this.loadCurrentUploadFolder();
  }

  async loadCurrentUploadFolder() {
    this.setState({isLoading: true});

    const {connectionId, casefolderId} = this.props;

    try {
      const response = await request
        .get(`/rpc/integrations/connections/${connectionId}/casefolders/${casefolderId}/upload-path`)

      this.setState({uploadFolder: response.body.folder_path});
    } catch (e) {
      if (!e.response.status === 404)
        notify.error("Failed to load current upload folder");
    } finally {
      this.setState({isLoading: false});
    }
  }

  // return true if we can show the folder selection UI
  canEditFolderSelection() {
    if (this.props.service === 'sharepoint' && !this.state.sharepointDrive)
      return false;

    return true;
  }

  openFolderTree = () => {
    this.setState({
      newFolderPath: [],
      isFolderTreeOpen: true
    });
  };

  closeFolderTree = () => {
    this.setState({isFolderTreeOpen: false, newFolderPath: []})
  }

  saveFolderPath = () => {
    this.setState({isSavingFolderPath: true});

    const {connectionId, casefolderId} = this.props;

    const folderPath = this.state.newFolderPath.join('/');

    request.post(`/rpc/integrations/connections/${connectionId}/casefolders/${casefolderId}/upload-path`)
      .send({folder_path: folderPath})
      .then(() => {
        this.setState({isSavingFolderPath: false, uploadFolder: folderPath})

        notify.success('Case folder Upload Path Saved');

        this.closeFolderTree();
      })
      .catch(() => {
        notify.error('Failed to save Case folder Upload path');
      })
      .finally(() => {
        this.setState({isSavingFolderPath: false})
      });
  }

  // update sharepoint drive settings when they are saved
  updateSharepointSettings = (savedValues) => {
    const { site, drive } = savedValues;

    this.setState({
      sharepointDrive: drive,
      sharepointSite: site,
    });
  }

  render() {
    if (this.state.isLoading)
      return <ProgressBar now={100}/>;

    return (
      <div>
        <Notification/>

        {this.props.service === 'sharepoint' &&
          <SharepointCasefolderSettings
            connectionId={this.props.connectionId}
            casefolderId={this.props.casefolderId}
            onLoad={this.updateSharepointSettings}
            onSave={this.updateSharepointSettings}
          />
        }

        {this.props.service !== 'sharepoint' &&
          <p>Current Folder Selection: {this.state.uploadFolder || 'None'}<br/>
            {this.canEditFolderSelection() &&
            <Button disabled={this.state.isFolderTreeOpen}
                    onClick={this.openFolderTree}
                    bsSize="sm"
            >Edit</Button>
            }
          </p>
        }

        {this.canEditFolderSelection() &&
          <div>
            {this.state.isFolderTreeOpen &&
            <p>New Selection: {this.state.newFolderPath.join('/') || 'None'}<br/>
              <Button bsSize="sm"
                      onClick={this.saveFolderPath}
                      disabled={this.state.isSavingFolderPath}>
                Save
              </Button>
              {' '}<Button bsSize="sm" bsStyle="danger" onClick={this.closeFolderTree}>Cancel</Button>
            </p>
            }

            {this.state.isFolderTreeOpen &&
            <UploadFolderTree
              connectionId={this.props.connectionId}
              casefolderId={this.props.casefolderId}
              service={this.props.service}
              sharepointSite={this.state.sharepointSite}
              sharepointDrive={this.state.sharepointDrive}
              onFinalValueChange={(value) => this.setState({newFolderPath: value})}
            />
            }
          </div>
        }
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/UploadFolderSelect.jsx